export const SUB_OBJECT = {
  alias: '',
  hint: '',
  role: '',
  value: '',
};
